import { z } from "zod";

import { type UserAddress, UserAddressSchema } from "./address";
import { type UserCoordinate, UserCoordinateSchema } from "./cordinate";

export type UserLocation = {
  coordinates: UserCoordinate;
  address: UserAddress;
};

export const UserLocationSchema = z.object({
  address: UserAddressSchema,
  coordinates: UserCoordinateSchema,
});
